import execa from "execa";

export interface ShellApi {
    exec(command: string, args?: string[]): Promise<string>;
}

const shell = () => {
    const api: ShellApi = {
        exec: async (command, args = []) => {
            const { stdout } = await execa(command, args, {
                env: process.env,
                cwd: process.cwd(),
            });

            return stdout;
        },
    };

    return api;
};

export default shell;
